import { Locale } from '@frontend/common';
import { IUser, UserSource, UserStateName } from '@frontend/user/types';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function formatUniqueIdentifierFallback(uniqueIdentifier: string): string {
    return UUID_REGEX.test(uniqueIdentifier) ? `ID: ${uniqueIdentifier}` : uniqueIdentifier;
}

export class User implements IUser {
    first_name: string | null;
    last_name: string | null;
    email: string | null;
    mobile: string | null;
    language: Locale;
    unique_identifier: string;
    department: string | null;
    source: UserSource | null;
    state: UserStateName;
    workflow_id: string | null;
    account_id: string;
    id: string;
    creation_timestamp: string;
    update_timestamp: string;
    delete_timestamp: string | null;
    owner_id: string | null;
    eula_accepted_timestamp: string | null;

    constructor(user: IUser) {
        this.first_name = user.first_name;
        this.last_name = user.last_name;
        this.email = user.email;
        this.mobile = user.mobile;
        this.language = user.language;
        this.unique_identifier = user.unique_identifier;
        this.department = user.department;
        this.source = user.source;
        this.state = user.state;
        this.workflow_id = user.workflow_id;
        this.account_id = user.account_id;
        this.id = user.id;
        this.creation_timestamp = user.creation_timestamp;
        this.update_timestamp = user.update_timestamp;
        this.delete_timestamp = user.delete_timestamp;
        this.owner_id = user.owner_id;
        this.eula_accepted_timestamp = user.eula_accepted_timestamp;
    }

    getDisplayName(): string {
        const parts: string[] = [];
        if (this.first_name) parts.push(this.first_name);
        if (this.last_name) parts.push(this.last_name);

        let base: string;
        if (parts.length > 0) {
            base = parts.join(' ');
        } else if (this.email) {
            base = this.email;
        } else if (this.mobile) {
            base = this.mobile;
        } else {
            base = formatUniqueIdentifierFallback(this.unique_identifier);
        }

        return this.department ? `${base} (${this.department})` : base;
    }

    getInitials(): string {
        const firstInitial = this.first_name?.charAt(0).toUpperCase() ?? '';
        const lastInitial = this.last_name?.charAt(0).toUpperCase() ?? '';

        if (!firstInitial && !lastInitial) {
            return 'U';
        }
        return `${firstInitial}${lastInitial}`;
    }
}
